"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationRow = void 0;
var Ceramic = __importStar(require("@amzn/ceramic-jsx"));
var ceramic_jsx_1 = require("@amzn/ceramic-jsx");
var Constants_1 = require("../constants/Constants");
var Utils_1 = require("../assets/scripts/Utils");
var textAttribute = function (horizontalGravity) {
    return {
        verticalGravity: "middle",
        horizontalGravity: horizontalGravity
    };
};
var TextDataRow = function (props) {
    return (Ceramic.createCeramicElement(ceramic_jsx_1.LinearContainer, { orientation: "horizontal", padding: {
            top: '5dp'
        } }, props.textItems.map(function (item, index) {
        return Ceramic.createCeramicElement(ceramic_jsx_1.Text, { value: item.value, width: index === props.textItems.length - 1 ? '34%' : '33%', font: Constants_1.textFontProps, color: item.color, textAttribute: textAttribute(item.gravity) });
    })));
};
var NavigationRow = function () {
    return (Ceramic.createCeramicElement(ceramic_jsx_1.Template, { templateName: "NavigationRow", componentProps: {}, additionalProps: {} },
        Ceramic.createCeramicElement(ceramic_jsx_1.ListRow, { id: "#[id]", orientation: "vertical", selected: false, on: {
                click: function (event) {
                    Utils_1.Utils.navigateToPage(Utils_1.Utils.Constants.Apis.DetailsPageNavigationApi);
                    return true;
                }
            } },
            Ceramic.createCeramicElement(ceramic_jsx_1.LinearContainer, { orientation: "horizontal", padding: '16dp 16dp 16dp 16dp', height: "wrap", border: {
                    bottom: {
                        width: "1dp",
                        color: "#D5D7D9"
                    }
                } },
                Ceramic.createCeramicElement(ceramic_jsx_1.LinearContainer, { orientation: "vertical", width: '95%' },
                    Ceramic.createCeramicElement(ceramic_jsx_1.LinearContainer, { orientation: "horizontal" },
                        Ceramic.createCeramicElement(ceramic_jsx_1.Text, { value: "#[id]", width: '80%', font: {
                                size: '15dp',
                                family: 'Amazon Ember',
                                weight: "bold"
                            }, color: Constants_1.ManageShipmentPageColors.headingTextColor, textAttribute: textAttribute("start") }),
                        Ceramic.createCeramicElement(ceramic_jsx_1.Text, { value: "#[status]", width: '20%', font: Constants_1.textFontProps, color: "#[badgeColor]", textAttribute: textAttribute("center") })),
                    Ceramic.createCeramicElement(TextDataRow, { textItems: [
                            { value: 'Origin', color: Constants_1.ManageShipmentPageColors.headingTextColor, gravity: "start" },
                            { value: 'Destination', color: Constants_1.ManageShipmentPageColors.headingTextColor, gravity: "center" },
                            { value: 'Units', color: Constants_1.ManageShipmentPageColors.headingTextColor, gravity: "end" }
                        ] }),
                    Ceramic.createCeramicElement(TextDataRow, { textItems: [
                            { value: '#[origin]', color: Constants_1.ManageShipmentPageColors.textColor, gravity: "start" },
                            { value: '#[destination]', color: Constants_1.ManageShipmentPageColors.textColor, gravity: "center" },
                            { value: '#[units]', color: Constants_1.ManageShipmentPageColors.textColor, gravity: "end" }
                        ] })),
                Ceramic.createCeramicElement(ceramic_jsx_1.Text, { value: "<icon name='content_icon_chevron_right'/>", width: '5%', enableHTML: true, textAttribute: textAttribute("center") })))));
};
exports.NavigationRow = NavigationRow;
